export default __webpack_public_path__ + "static/media/e149457fe06c3713196a852351877e4b1580221337842.1fbefda2.webp";